import type { ReactNode } from 'react'
import { NavLink, Outlet } from 'react-router-dom'

import { useApp } from '../state/AppState'
import { Wordmark } from '../ui/primitives'
import styles from './shell.module.css'

/// Разделы верхнего меню повторяют структуру сайта: каталог, обмен,
/// сообщество. Порядок — от «зачем пришли» к «чем ещё заняться».
///
/// `personal` — раздел, которого у гостя нет: маршруты под ним не
/// объявлены (см. App.tsx), и ссылка вела бы в редирект на каталог.
const NAV = [
  { to: '/collections', title: 'Коллекции', personal: false },
  { to: '/my', title: 'Моя коллекция', personal: true },
  { to: '/matching', title: 'Обмены', personal: true },
  { to: '/trades', title: 'Сделки', personal: true },
  { to: '/messages', title: 'Сообщения', personal: true },
  { to: '/auctions', title: 'Аукцион', personal: false },
  { to: '/shop', title: 'Магазин', personal: false },
  { to: '/forum', title: 'Форум', personal: false },
  { to: '/profile', title: 'Кабинет', personal: true }
]

export function Shell(): ReactNode {
  const app = useApp()
  const entries = NAV.filter(
    (entry) => app.isAuthenticated || !entry.personal
  )

  return (
    <div className={styles.shell}>
      <header className={styles.header}>
        <NavLink to="/collections">
          <Wordmark />
        </NavLink>
        <nav className={styles.nav}>
          {entries.map((entry) => (
            <NavLink
              key={entry.to}
              to={entry.to}
              className={({ isActive }) =>
                [styles.navLink, isActive ? styles.navLinkActive : '']
                  .filter(Boolean)
                  .join(' ')
              }
            >
              {entry.title}
            </NavLink>
          ))}
          {!app.isAuthenticated && (
            <NavLink
              to="/login"
              className={({ isActive }) =>
                [styles.navLink, isActive ? styles.navLinkActive : '']
                  .filter(Boolean)
                  .join(' ')
              }
            >
              Войти
            </NavLink>
          )}
        </nav>
      </header>

      <main className={styles.content}>
        <Outlet />
      </main>

      <footer className={`${styles.footer} label`}>
        Кардбазар — обмен наклейками и карточками
      </footer>
    </div>
  )
}

export function Splash(): ReactNode {
  return (
    <div className={styles.content}>
      <span className="label">Загрузка…</span>
    </div>
  )
}
